<template>
  <div class="form-container container-fluid acteurForm">
    <div class="col-md-12 center-block acteurTitle">
      <h3>{{acteurTitle}} :{{dataActeur.RaisonSociale}}
        <span class="pull-right">
        <small>s'agit-il d'une personne physique ?
          <go-switch v-model="dataActeur.isActeurPhysique"></go-switch>
        </small>
          &nbsp;&nbsp;
        <button id="cmdActeurSave" v-on:click="saveData" :disabled="!isFormValid" class="btn btn-primary">SAUVER</button>
        </span>
      </h3>

    </div>
    <form class="form-horizontal">
      <template v-if="!dataActeur.isActeurPhysique">
        <div class="form-group">
          <label for="listActeur" class="control-label col-sm-3">Recherche d'une société: </label>
        <!--    http://sagalbot.github.io/vue-select/-->
          <div class="col-sm-9">
            <v-select id="listActeur" tabindex="-1"
                      :debounce="250"
                      :on-search="_getOptions"
                      :options="options"
                      placeholder="Saisissez quelques lettres se trouvant dans le nom d'une société"
                      label="label"
                      :value="dataSelected"
                      :onChange="changeSelected"
                      title="A partir de la troisième lettre saisie, une recherche de nom de société contenant ces lettres est effectuée... ">
            </v-select>
          </div>
        </div>
      </template>

      <div class="form-group "
          v-bind:class="{'has-success has-feedback':  dataActeur.RaisonSocialeIsValid,
            'has-warning has-feedback': !dataActeur.RaisonSocialeIsValid}">
        <label for="RaisonSociale" class="control-label col-sm-3">
          <template v-if="!dataActeur.isActeurPhysique">Nom de la Société:</template>
          <template v-else="">Nom et Prénom de la Personne:</template>
        </label>
        <div class="col-sm-9">
          <input id="RaisonSociale" v-model="dataActeur.RaisonSociale"
                 @input="changeAnyFields"
                 type="text" class="form-control"
                 placeholder="La saisie de ce champ est obligatoire"/>
          <template v-if="dataActeur.RaisonSocialeIsValid">
            <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true"></span>
            <span id="inputRaisonSocialeStatus" class="sr-only">(success)</span>
          </template>
          <template v-else="">
            <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"></span>
            <span id="inputRaisonSocialeStatus" class="sr-only">(error)</span>
          </template>
        </div>
      </div>

      <div class="form-group">
        <label for="RueNumero" class="control-label col-sm-3">Adresse : </label>
        <div class="col-sm-9">
          <input id="RueNumero" v-model="dataActeur.RueNumero" type="text" class="form-control"/>
        </div>
      </div>

      <div class="form-group">
        <label for="CPVille" class="control-label col-sm-3">Code Postal et Ville: </label>
        <div class="col-sm-9">
          <input id="CPVille" v-model="dataActeur.CPVille" type="text" class="form-control"/>
        </div>
      </div>

      <div class="form-group">
        <label for="Telephone" class="control-label col-sm-3">Téléphone: </label>
        <div class="col-sm-9">
          <input id="Telephone" v-model="dataActeur.Telephone" type="text" class="form-control"/>
        </div>
      </div>

      <div class="form-group">
        <label for="TelephonePortable" class="control-label col-sm-3">Téléphone portable: </label>
        <div class="col-sm-9">
          <input id="TelephonePortable" v-model="dataActeur.TelephonePortable" type="text" class="form-control"/>
        </div>
      </div>

      <div class="form-group">
        <label for="Fax" class="control-label col-sm-3">Fax: </label>
        <div class="col-sm-9">
          <input id="Fax" v-model="dataActeur.Fax" type="text" class="form-control"/>
        </div>
      </div>

      <div class="form-group">
        <label for="Email" class="control-label col-sm-3">Courriel du {{acteurTitle}}: </label>
        <div class="col-sm-9">
          <input id="Email" v-model="dataActeur.Email" type="text" class="form-control"/>
        </div>
      </div>
      <p v-if="dataActeur.RaisonSociale && isItDevEnv">Inside goSelect dataActeur is : <br>{{dataActeur}}</p>
    </form>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import goSwitch from '../ui/goSwitch.vue'
  import axios from 'axios'
  import {BASE_REST_API_URL, DEV, getLog} from '../config'

  const log = getLog('goSelectActeur', 4, 1)

  export default {
    name: 'goSelectActeur',
    components: {
      vSelect,
      goSwitch
    },
    props: {
      value: {
        type: Object
        // default: () => {}
        /*
         ici je decide volontairement de pas renvoyer un default
         ca m'economise tout le boulot d'emit quand on change data ici
         et le traitement des evenements dans le parent...
         je sais ce que vous allez dire ! j'utilise le fait que la value est un objet
         et que donc il est passe par reference et que donc quand je le change dans ce composant et ben dans le parent
         l'objet et ben il change aussi vu que c'est le meme objet
         ouaipp  je sais c'est pas bien, mais ca fonctionne pil poil
         faut juste etre au clair et faire gaffe a ce qu'on fait
         et bien definir toute la hierarchie dans le data du parent sinon vuejs ce plante pour les mises a jour
         et il ne peut plus suivre qui change quoi et rafraichir le dom
         promis Docteur : des que j'avance un peu j'implement un joli event changeFieldsValue
         que je traiterais dans le parent pour chaque instance...
         */
      },
      acteurTitle: {
        type: String,
        default: 'Maître d\'ouvrage'
      }
    }, // end of props section
    data: function () {
      return {
        isItDevEnv: DEV,
        dataActeur: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        dataSelected: null,
        test: null,
        options: []
      }
    }, // end of data section
    computed: {
      isFormValid: function () {
        if (this.dataActeur.RaisonSociale) {
          this.dataActeur.isActeurValid = true
          this.dataActeur.RaisonSocialeIsValid = true
          return true
        } else {
          this.dataActeur.isActeurValid = false
          this.dataActeur.RaisonSocialeIsValid = false
          return false
        }
      }
    }, // end of computed props section
    watch: {
      value (val) {
        this.dataActeur = val
      }
    }, // end of watch props section
    created: function () {
      log.l('## INSIDE goSelectActeur created ')
    },
    mounted: function () {
      log.l('## INSIDE goSelectActeur mounted ')
      // this.dataSelected = this.value
    }, // end of mounted props section

    methods: {
      changeSelected (val) {
        if (val !== null) {
          this._getActeurDataFromRemote(val.value)
        } else {
          this._initDataActeur()
          this.$emit('input', this.dataActeur)
        }
      },
      changeAnyFields (val) {
        this.$emit('input', this.dataActeur)
        log.l(`## IN goSelectActeur.changeAnyFields\n ->${val.srcElement.id}.value=[${val.srcElement.value}]`)
      },
      saveData () {
        log.l(`## IN goSelectActeur.saveData request emitted ! `)
        this.$emit('saverequest', this.dataActeur)
      },
      _initDataActeur () {
        this.dataActeur = {
          IdActeurSelected: null,
          RaisonSociale: null,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        }
      },
      _getOptions (search, loading) {
        log.l(`## Entering IN goSelectActeur.getOptions search:${search}`)
        // private method to retrieve data from server
        if (search.length > 2) {
          axios.get(`${BASE_REST_API_URL}/acteurs/${search}`)
          .then(resp => {
            if (resp.data.length > 0) {
              this.options = resp.data
            } else {
              if (resp.data[0].value === 0) {
                this.options = resp.data
                log.w(`## IN goSelectActeur.getOptions data IS EMPTY for search:${search}`, resp.data)
              }
            }
            if (DEV) {
              log.l(`## IN goSelectActeur.getOptions after finish loading data for search:${search}`)
            }
            loading(false)
          })
          .catch(err => {
            log.e(`### ERROR IN goSelectActeur.getOptions for search:${search}`, err.response)
            loading(false)
          })
        }
      },
      _getActeurDataFromRemote (idActeur) {
        if (idActeur !== 0) {
          axios.get(`${BASE_REST_API_URL}/acteur/${idActeur}`)
          .then(resp => {
            this.dataActeur.IdActeurSelected = resp.data[0]['id']
            this.dataActeur.RaisonSociale = resp.data[0]['nom']
            this.dataActeur.RueNumero = resp.data[0]['rue'] + ' ' + resp.data[0]['numero']
            this.dataActeur.CPVille = resp.data[0]['codepostal'] + ' ' + resp.data[0]['ville']
            this.dataActeur.Telephone = resp.data[0]['telephone']
            // this.TelephonePortable  = resp.data[0]['nom']
            this.dataActeur.Fax = resp.data[0]['fax']
            this.dataActeur.Email = resp.data[0]['email']
            this.$emit('input', this.dataActeur)
            if (DEV) {
              log.l(`## IN goSelectActeur.getActeurData after finish loading data for search:${idActeur}`)
            }
          })
          .catch(err => {
            log.e(`### ERROR IN goSelectActeur.getActeurData for search:${idActeur}`, err.response)
          })
        }
      },
      getCurrentData () {
        let data = {
          'id': this.IdActeurSelected,
          'RaisonSociale': `"${this.RaisonSociale}"`,
          'RueNumero': `"${this.RueNumero}"`,
          'CPVille': `"${this.CPVille}"`,
          'Telephone': `"${this.Telephone}"`,
          'TelephonePortable': `"${this.TelephonePortable}"`,
          'Fax': `"${this.Fax}"`,
          'Email': `"${this.Email}"`
        }
        return data
      }
    } // end of methods section
  }
</script>


<style lang="scss">
  @import '../../styles/imports';

  @media (max-width: 600px) {
    .v-select input[type=search] {
      width: 500px;
    }
  }

  .acteurTitle {
    padding: 3px 5px;
    h3 {
      margin: 0px 0px 15px 0px;
      font-size: 1.5em;
      font-weight: bold;
    }
  }

  .acteurForm {
    /* background-color: #31c8f6;*/
    border-bottom: solid 1px black;
  }

</style>



// WEBPACK FOOTER //
// src/components/geo/goSelectActeur.vue